import React from 'react';
import {Modal, Button} from 'antd';

const ConfirmGiftChangeStatusToFreeModal = ({onClose, onSubmit}: any) => {
    return (
        <Modal
            visible={true}
            closable={false}
            title="Подтверждение смены статуса"
            footer={[
                <Button key="1" color="secondary" onClick={onClose} className="custom-btn custom-btn__cancel">
                    Отменить
                </Button>,
                <Button key="2" color="primary" onClick={onSubmit} className="custom-btn custom-btn__consent">
                    Изменить статус
                </Button>,
            ]}
        >
            <div>
                Если вы это сделаете, все данные Исполнителя сотрутся.
                <br />
                Вы уверенны, что хотите изменить <strong>статус на Свободен?</strong>
            </div>
        </Modal>
    );
};

export default ConfirmGiftChangeStatusToFreeModal;
